import React from 'react';

const getLocalDigits = (value) => {
  const digits = String(value || '').replace(/\D/g, '');
  if (digits.startsWith('256')) return digits.slice(3, 12);
  return digits.replace(/^0/, '').slice(0, 9);
};

export default function UgandaPhoneInput({ value, onChange, className = '', inputClassName = '', ...props }) {
  const updateValue = (rawValue) => {
    const localDigits = getLocalDigits(rawValue);
    onChange(localDigits ? `256${localDigits}` : '');
  };

  const handlePaste = (event) => {
    event.preventDefault();
    updateValue(event.clipboardData.getData('text'));
  };

  return (
    <div className={`flex h-12 w-full items-center overflow-hidden rounded-xl border border-neutral-200 bg-neutral-50 focus-within:border-neutral-400 focus-within:bg-white ${className}`}>
      <span className="flex h-full shrink-0 items-center border-r border-neutral-200 px-3 text-[15px] font-medium text-neutral-600">
        +256
      </span>
      <input
        {...props}
        type="tel"
        inputMode="numeric"
        autoComplete="tel-national"
        maxLength={9}
        value={getLocalDigits(value)}
        onChange={(event) => updateValue(event.target.value)}
        onPaste={handlePaste}
        className={`h-full min-w-0 flex-1 bg-transparent px-3 text-[15px] text-neutral-950 outline-none placeholder:text-neutral-400 ${inputClassName}`}
        placeholder="700 000 000"
        aria-label={props['aria-label'] || 'Uganda phone number'}
      />
    </div>
  );
}
